import { Component, Directive, input, TemplateRef } from '@angular/core'

@Component({
	selector: '[lowgile-chevron-step]',
	template: `
		<div
			class="step"
			[class.step-beginning]="isBeginning()"
			[class.step-end]="isEnd()"
		>
			<div class="inner">
				<ng-content></ng-content>
			</div>
		</div>
	`,
	standalone: true,
	styleUrls: ['./chevron-step.component.scss'],
})
export class ChevronStepComponent {
	isBeginning = input(false)
	isEnd = input(false)
}
